export default __webpack_public_path__ + "static/media/Compare-active.518e3988.svg";